import useAccount from '@tcs/client-portal-common/hooks/useAccount';
export const useIsUserRMD = (accountNumber: string): boolean => {
  const { loading: loadingAccount, data: account } = useAccount(accountNumber);

  if (loadingAccount) {
    return false;
  }

  return account.isInRMDStatus;
};

export default useIsUserRMD;
